/**
 * Created by andrey on 12.09.2025
 */

const LabSysTechLogic = function () {
    PlatformLogic.call(this);
};

LabSysTechLogic.prototype = Object.create(PlatformLogic.prototype);
LabSysTechLogic.prototype.constructor = LabSysTechLogic;

LabSysTechLogic.prototype.logPushes = function () {
    const params = connector.utils.getRequestParameters();

    const pushCode = params.push_code;
    if (pushCode) {
        this.logClickEvent(pushCode);
    }
};

LabSysTechLogic.prototype.loadOldUserId = function (callback) {
    let oldUser;
    try {
        oldUser = cleverapps.dataLoader.localStorage.getItem(cleverapps.config.name);
        callback(oldUser && JSON.parse(oldUser).id);
    } catch (e) {
        console.log(`parse old user error - ${oldUser}`, e);
    }
};